"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uclientHasNTPError = exports.isUclientVersionUpdateToDate = exports.isUClientOrphaned = exports.isUClientOffline = exports.isUClientLockedByOtherHost = exports.isUClientLocked = exports.isUClientFree = exports.isNewUclient = exports.isNewUClient = exports.initUClientAcion = exports.getUClientType = exports.getUClientStatus = exports.getUClientName = exports.getDistinctSubnetsForUClients = exports.getAppVersion = exports.doesUClientNeedFirmwareUpdate = exports.canLockUClient = exports.areUClientsInSameSubnet = exports.areIPsInSameSubnet = exports.UCLIENT_REQUIRED_VERSION = void 0;
var _lt = _interopRequireDefault(require("semver/functions/lt"));
var _eq = _interopRequireDefault(require("semver/functions/eq"));
var _uuid = require("uuid");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var UCLIENT_REQUIRED_VERSION = exports.UCLIENT_REQUIRED_VERSION = "2.2.6";
var isNewUClient = exports.isNewUClient = function isNewUClient(uClient) {
  return uClient.id.value.split("-")[2] === "uclient2";
};
var isUclientVersionUpdateToDate = exports.isUclientVersionUpdateToDate = function isUclientVersionUpdateToDate(currentVersion, requiredVersion) {
  if (!currentVersion) {
    return true;
  }
  var realVersion = typeof currentVersion === "string" || currentVersion instanceof String ? currentVersion : currentVersion.version;
  var currentSemverVersion = realVersion.split(".").slice(0, 3).join(".");
  // console.log("currentVersion: " + currentVersion + " currentSemverVersion:" + currentSemverVersion);
  requiredVersion = requiredVersion ? requiredVersion : UCLIENT_REQUIRED_VERSION;
  var requiredSemverVersion = requiredVersion.split(".").slice(0, 3).join(".");
  // console.log("requiredVersion: " + requiredVersion + " requiredSemverVersion:" + requiredSemverVersion);

  try {
    var isUClientNeedUpdate = (0, _lt["default"])(currentSemverVersion, requiredSemverVersion) || (0, _eq["default"])(currentSemverVersion, requiredSemverVersion) && realVersion !== requiredVersion;
    return !isUClientNeedUpdate;
  } catch (error) {
    return true;
  }
};
function findFirmware(model, firmwareMapping) {
  if (firmwareMapping) {
    for (var configModel in firmwareMapping) {
      if (model.toUpperCase().indexOf(configModel.toUpperCase()) >= 0) {
        return firmwareMapping[configModel];
      }
    }
  }
  return null;
}
var isNewUclient = exports.isNewUclient = function isNewUclient(uClient) {
  return uClient.id.value.split("-")[2] === "uclient2";
};
var getAppVersion = exports.getAppVersion = function getAppVersion(uClient, appVersion) {
  if (!appVersion) {
    return "";
  }
  if (isNewUClient(uClient)) return appVersion.uClient2Version;
  return appVersion.uClient1Version;
};
var doesUClientNeedFirmwareUpdate = exports.doesUClientNeedFirmwareUpdate = function doesUClientNeedFirmwareUpdate(uClientFirmwareConfig, uClient) {
  var firmwareMapping = null;
  if (uClient.id.value.startsWith("seat-userful-uclient-webos") && uClientFirmwareConfig !== null && uClientFirmwareConfig !== void 0 && uClientFirmwareConfig.uClient1Config) {
    firmwareMapping = uClientFirmwareConfig.uClient1Config.webOSFirmwareMapping;
  } else if (uClient.id.value.startsWith("seat-userful-uclient-android") && uClientFirmwareConfig !== null && uClientFirmwareConfig !== void 0 && uClientFirmwareConfig.uClient1Config) {
    firmwareMapping = uClientFirmwareConfig.uClient1Config.androidFirmwareMapping;
  }
  if (uClient.id.value.startsWith("seat-userful-uclient2-webos") && uClientFirmwareConfig !== null && uClientFirmwareConfig !== void 0 && uClientFirmwareConfig.uClient2Config) {
    firmwareMapping = uClientFirmwareConfig.uClient2Config.webOSFirmwareMapping;
  } else if (uClient.id.value.startsWith("seat-userful-uclient2-android") && uClientFirmwareConfig !== null && uClientFirmwareConfig !== void 0 && uClientFirmwareConfig.uClient2Config) {
    firmwareMapping = uClientFirmwareConfig.uClient2Config.androidFirmwareMapping;
  }
  if (firmwareMapping) {
    var modelName = uClient.transientData.hardwareData.modelName;
    // console.log("needFirmwareUpdate - modelName=" + modelName);
    var requiredFirmware = findFirmware(modelName, firmwareMapping);
    // console.log("needFirmwareUpdate - firmwareMapping=", modelName);
    if (modelName && requiredFirmware) {
      var currentFirmware = uClient.transientData.hardwareData.firmwareVersion;
      // For testing.
      //const currentFirmware = "0.0.1";
      // console.log("needFirmwareUpdate - requiredFirmware=" + requiredFirmware + " currentFirmware=" + currentFirmware);
      if (requiredFirmware !== currentFirmware) {
        return {
          currentFirmware: currentFirmware,
          requiredFirmware: requiredFirmware,
          requireUpdate: true
        };
      }
    }
  }
  return {
    currentFirmware: "",
    requiredFirmware: "",
    requireUpdate: false
  };
};
var isUClientOffline = exports.isUClientOffline = function isUClientOffline(uc) {
  if (!uc.transientData) {
    return true;
  }
  var status = uc.transientData.connectionStatus.connectionStatus;
  return status === "OFFLINE";
};
var canLockUClient = exports.canLockUClient = function canLockUClient(uc) {
  if (!uc.transientData) {
    return false;
  }
  var status = uc.transientData.connectionStatus.connectionStatus;
  return status === "FREE" || status === "ORPHAN";
};
var isUClientOrphaned = exports.isUClientOrphaned = function isUClientOrphaned(uc) {
  if (!uc.transientData) {
    return false;
  }
  var status = uc.transientData.connectionStatus.connectionStatus;
  return status === "ORPHAN";
};
var isUClientLocked = exports.isUClientLocked = function isUClientLocked(uc) {
  if (!uc.transientData) {
    return false;
  }
  var status = uc.transientData.connectionStatus.connectionStatus;
  return status === "CONNECTED";
};
var isUClientLockedByOtherHost = exports.isUClientLockedByOtherHost = function isUClientLockedByOtherHost(uc) {
  if (isUClientOffline(uc)) {
    return true;
  }
  if (!uc.transientData) {
    return false;
  }
  var status = uc.transientData.connectionStatus.connectionStatus;
  return status === "OCCUPY";
};
var isUClientFree = exports.isUClientFree = function isUClientFree(uc) {
  if (!uc.transientData) {
    return false;
  }
  var status = uc.transientData.connectionStatus.connectionStatus;
  return status === "FREE";
};
var getUClientStatus = exports.getUClientStatus = function getUClientStatus(uc) {
  if (isUClientOrphaned(uc)) return "ORPHAN";
  if (isUClientFree(uc)) return "FREE";
  if (isUClientLocked(uc)) return "CONNECTED";
  if (isUClientOffline(uc)) return "OFFLINE";
  return "UNKNOWN";
};
var getUClientType = exports.getUClientType = function getUClientType(uc) {
  if (uc.id.value.includes("-tizen")) {
    return "tizen";
  }
  if (uc.id.value.includes("-webos")) {
    return "webos";
  }
  return "android";
};
var ITAIGA_FIRMWARE = "RK3588";
var ANDROID_FIRMWARE = "rockchip";
var ANDROID_FIRMWARE2 = "RK3399";
var getUClientName = exports.getUClientName = function getUClientName(uc) {
  var _uc$transientData;
  if ((_uc$transientData = uc.transientData) !== null && _uc$transientData !== void 0 && _uc$transientData.name) {
    return uc.transientData.name;
  }
  var modelName = uc.transientData ? uc.transientData.hardwareData.manufacturer + " " + uc.transientData.hardwareData.modelName : "Unknown";
  // Giada
  if (uc.id.value.includes("giada")) {
    return modelName;
  }
  // LG
  if (getUClientType(uc) === "webos") {
    return "WebOS";
  }
  // Samsung
  if (getUClientType(uc) === "tizen") {
    return modelName;
  }
  // Sony (android)
  if (modelName.toLocaleLowerCase().includes("sony")) {
    return modelName;
  }
  // iTayga
  if (modelName.toLocaleLowerCase().includes("rk3588")) {
    return "I300A";
  }
  // Weibu
  if (modelName.toLocaleLowerCase().includes("rk3399")) {
    return "W100A";
  }

  // unknown uclient
  return modelName;
};
var getDistinctSubnetsForUClients = exports.getDistinctSubnetsForUClients = function getDistinctSubnetsForUClients(uclients) {
  var lockedAndOnline = uclients.filter(function (u) {
    return isUClientLocked(u) && !isUClientOffline(u);
  });
  var distinctUClientSubnets = lockedAndOnline.reduce(function (acc, curr) {
    if (acc.findIndex(function (u) {
      return areUClientsInSameSubnet(u, curr);
    }) < 0) {
      acc.push(curr);
    }
    return acc;
  }, []);
  return distinctUClientSubnets.map(function (u) {
    return "".concat(u.transientData.networkData.addressInfo.ipAddress.value, "/").concat(u.transientData.networkData.addressInfo.mask.value);
  });
};

// assuming both are locked and online
var areUClientsInSameSubnet = exports.areUClientsInSameSubnet = function areUClientsInSameSubnet(left, right) {
  if (left.transientData.networkData.addressInfo.mask.value !== right.transientData.networkData.addressInfo.mask.value) {
    return false;
  }
  return areIPsInSameSubnet(left.transientData.networkData.addressInfo.ipAddress.value, right.transientData.networkData.addressInfo.ipAddress.value, left.transientData.networkData.addressInfo.mask.value);
};
var areUClientInSameSubnetAsIP = function areUClientInSameSubnetAsIP(uclient, ip) {
  return areIPsInSameSubnet(ip, uclient.transientData.networkData.addressInfo.ipAddress.value, uclient.transientData.networkData.addressInfo.mask.value);
};

/**
 * check if uclient is not in the same network as NTP server
 * @param uclient
 * @param ips
 * @returns
 */
var uclientHasNTPError = exports.uclientHasNTPError = function uclientHasNTPError(uclient, selectedNTPIP, allNICIPs) {
  if (!isUClientLocked(uclient) || isUClientOffline(uclient)) {
    return false;
  }
  if (getUClientType(uclient) !== "webos") {
    // only webos cares about static ntp server
    return false;
  }
  if (areUClientInSameSubnetAsIP(uclient, selectedNTPIP)) {
    // uclient is in the same network
    return false;
  }
  if (allNICIPs.findIndex(function (ip) {
    return areUClientInSameSubnetAsIP(uclient, ip);
  }) >= 0) {
    // there is another NIC (not selected) that's in the same network as uclient => error
    return true;
  }
  // no good selection, so probably has custom routing rules and user should set a custom NTP
  return false;
};
var areIPsInSameSubnet = exports.areIPsInSameSubnet = function areIPsInSameSubnet(ip1, ip2, mask) {
  if (!ip1 || !ip2 || !mask) {
    return false;
  }
  try {
    var ip1Parts = ip1.split(".").map(function (p) {
      return Number(p);
    });
    var ip2Parts = ip2.split(".").map(function (p) {
      return Number(p);
    });
    var maskParts = mask.split(".").map(function (p) {
      return Number(p);
    });
    for (var i = 0; i < 4; i++) {
      if ((ip1Parts[i] & maskParts[i]) !== (ip2Parts[i] & maskParts[i])) {
        return false;
      }
    }
    return true;
  } catch (e) {
    console.warn("Failed to parse ip address ", e);
  }
  return false;
};
var initUClientAcion = exports.initUClientAcion = function initUClientAcion() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    name: "UClient Action",
    description: "UClient Action",
    displays: [],
    timeZone: {
      value: Intl.DateTimeFormat().resolvedOptions().timeZone
    },
    type: "DISPLAY_OFF"
  };
};